import { render, staticRenderFns } from "./HoldTabSwitch.vue?vue&type=template&id=4d78ccba&scoped=true&"
import script from "./HoldTabSwitch.vue?vue&type=script&lang=js&"
export * from "./HoldTabSwitch.vue?vue&type=script&lang=js&"
import style0 from "./HoldTabSwitch.vue?vue&type=style&index=0&id=4d78ccba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78ccba",
  null
  
)

export default component.exports